import { gql } from '@apollo/client'

export type MutationVars = {
  userId: string
  customerId: string
  subjectId: string
  isEscalated: boolean
  reason: string
}

export type Response = {
  editEscalation: string
}

const mutation = gql`
  mutation editEscalation(
    $userId: ID!
    $customerId: ID!
    $subjectId: ID!
    $isEscalated: Boolean!
    $reason: String!
  ) {
    editEscalation(
      userId: $userId
      customerId: $customerId
      subjectId: $subjectId
      isEscalated: $isEscalated
      reason: $reason
    )
  }
`

export default mutation
